<template>
  <div class="header">
    <transition name="fade">
      <div v-if="showPrompt" class="prompt" :class="{ 'mobile-prompt': isMobile }">
        <div class="prompt-content">
          <p>{{ $t('browser_layer') }}</p>
          <span class="el-icon-close" @click="closePrompt"></span>
        </div>
      </div>
    </transition>
    <div class="header-content">
      <div class="header-content-top">
        <span style="cursor: pointer" @click="goHome"
          ><img src="@/assets/images/hsk_mock_logo.png" alt="" style="height: 30px"
        /></span>
        <div v-if="!isMobile" style="display: flex; align-items: center; column-gap: 80px">
          <nav-menu></nav-menu>
          <user-option></user-option>
        </div>
        <!-- <user-avatar v-else></user-avatar> -->
        <template v-if="isMobile">
          <div style="display: flex; align-items: center; column-gap: 10px">
            <user-function></user-function>
            <img :src="require('@/assets/images/list.svg')" @click="toggleMobileMenu" />

            <div v-show="showMobileMenu" class="mobile-menu">
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  padding-top: 10px;
                  padding-right: 4px;
                "
              >
                <img
                  :src="require('@/assets/images/close.png')"
                  style="width: 36px"
                  @click="toggleMobileMenu"
                />
              </div>

              <div class="menu-wrapper">
                <router-link :to="'/chooselevel'">{{ $t('mock_tests') }}</router-link>
                <span>{{ $t('support') }}</span>
                <div class="sub-menu">
                  <a :href="`/${isChinese ? 'cn' : 'en'}/index.html`">{{ $t('blog_and_faq') }}</a>
                  <router-link :to="'/feedback'">{{ $t('contact') }}</router-link>
                </div>
                <span>{{ $t('more_menu') }}</span>
                <div class="sub-menu">
                  <router-link :to="'/solutions'">{{ $t('for_institutions') }}</router-link>
                  <router-link :to="'/about'">{{ $t('about_us') }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import analytics from '@/utils/AnalyticsCenter'
import NavMenu from '@/components/Layout/components/SimpleMenu'
import UserOption from '@/components/Layout/components/UserOption'
import UserAvatar from '@/components/Layout/components/UserAvatar'
import UserFunction from '@/components/Layout/components/UserFunction'
import { isChrome } from '@/utils/browser'
export default {
  name: 'Header',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPrompt: null,
      showMobileMenu: false,
    }
  },
  components: {
    NavMenu,
    UserOption,
    UserAvatar,
    UserFunction,
  },
  mounted() {
    // 判断当前浏览器
    this.isShowPrompt()
  },
  computed: {
    isChinese() {
      let local = this.$i18n.locale || localStorage.getItem('language')
      return local === 'zh'
    },
  },
  methods: {
    goHome() {
      analytics.logEvent('hskweb_toplogo_click')
      this.$router.push('/')
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    // 判断是否是ios端的chrome浏览器
    isShowPrompt() {
      // 判断如果session中没有值并且是移动端的非chrome浏览器才展示
      if (!sessionStorage.getItem('hideBrowserLayer') && !isChrome()) this.showPrompt = true
    },
    closePrompt() {
      this.showPrompt = false
      sessionStorage.setItem('hideBrowserLayer', true)
    },
  },
  watch: {
    $route(to, from) {
      // 关闭移动端菜单
      this.showMobileMenu = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}
.fade-leave-to {
  opacity: 0;
}
.header {
  width: 100%;
  background: #2c2f46;
  position: sticky;
  top: 0;
  z-index: 30;
  .header-content {
    width: 1200px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    &-top {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .prompt {
    background-color: #faae56;
    min-height: 50px;
    display: flex;
    justify-content: center;
    &-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      p {
        font-size: 14px;
        text-align: center;
        flex: 1;
      }
      .el-icon-close {
        cursor: pointer;
      }
    }
    &.mobile-prompt {
      min-height: 40px;
      .prompt-content {
        width: 95vw;
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content {
    width: 100% !important;
    //height: 100px !important;
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-end !important;
    padding: 0 17px;
  }

  .mobile-menu {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.9);
    padding: 12px;

    .menu-wrapper {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      & > a,
      span {
        display: inline-block;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        padding: 12px 4px;
        color: #fff !important;

        &:last-child {
          border: none;
        }

        &.router-link-active {
          color: $yellow !important;
        }
      }

      & > .sub-menu {
        padding-left: 16px;
        display: flex;
        flex-direction: column;

        & > a {
          display: inline-block;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          padding: 8px 4px;
          color: #fff !important;

          &:last-child {
            border: none;
          }

          &.router-link-active {
            color: $yellow !important;
          }
        }
      }
    }
  }
}
</style>
